(function(ss) {

  var SocialShareWindow,
    socialShareUtil = ss.utils.imports('socialShareUtil'),
    DEFAULT_CONFIG = {
      strWindowFeatures: 'width=550,height=380,scrollbars=yes,resizable=yes'
    };

  if (!socialShareUtil) {
    throw new Error('SocialShareWindow dependency missing: SocialShareUtil');
  }

  /**
   * A utility for fetching a share url and opening it in a pop up
   * @param {Object} config
   * @param {String} config.url
   * @param {String} config.title
   * @param {String} config.description
   * @param {String} config.imageUrl
   * @param {String} config.serviceType
   * @returns {Object}
   */
  SocialShareWindow = function(config) {
    var config = $.extend( {}, DEFAULT_CONFIG, config),
      url = config.url || window.location.href,
      serviceType = socialShareUtil.getNormalizedServiceName(config.serviceType),
      title = config.title,
      description = config.description,
      imageUrl = config.imageUrl,
      strWindowFeatures = config.strWindowFeatures,
      shareWindowUrl = socialShareUtil.generateShareWindowUrl(serviceType, url, {
        title: title,
        description: description,
        imageUrl: imageUrl
      });

    return {
      open: function() {
        if (!socialShareUtil.isSupportedService(serviceType)) {
          throw new Error('Unsupported service: ' + serviceType);
        }
        window.open(shareWindowUrl, null, strWindowFeatures);
      }
    };
  };

  ss.utils.exports('SocialShareWindow', SocialShareWindow);
})(window.slideshare_object);
